module.exports = __webpack_public_path__ + "img/portrait-beer.d0bb523c.svg";